<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 417 417"
    class="svg-icon"
    style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"
  >
    <g>
      <path
        d="M208.333,-0c68.99,-0 125,56.011 125,125c0,68.989 -56.01,125 -125,125c-68.989,-0 -125,-56.011 -125,-125c0,-68.989 56.011,-125 125,-125Zm0,32.653c51.058,0 92.511,41.453 92.511,92.511c-0,51.057 -41.453,92.51 -92.511,92.51c-51.057,-0 -92.51,-41.453 -92.51,-92.51c0,-51.058 41.453,-92.511 92.51,-92.511Z"
      />
      <rect x="190.411" y="244.677" width="35.844" height="171.99" />
      <path d="M122.339,312.75l-0,35.844l171.989,0l0,-35.844l-171.989,-0Z" />
    </g>
  </svg>
</template>

<script>
export default {
  name: "IconFemale"
};
</script>
